import * as yup from "yup";

const banPassengerValidator = yup
  .object({ reason: yup.string().required("Reason is required") })
  .required();

export default banPassengerValidator;
